const { BlobServiceClient } = require("@azure/storage-blob");
const moment = require("moment");
const _ = require("lodash");
const url = "https://devlnxstorage.blob.core.windows.net";
const sas = process.env.REACT_APP_TOKEN_BLOB_UPLOAD;
const container = process.env.REACT_APP_CONTAINER;

const blobServiceClient = new BlobServiceClient(`${url}${sas}`);

const normalizeStr = (str) =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9-]/gi, "");

const getPath = (area, menu, card, aba, nome, extension) => {
  area = normalizeStr(area);
  card = normalizeStr(card);
  aba = normalizeStr(aba);
  let menu_split = menu.split("/");
  if(menu.includes("|")){
     menu_split = menu.split("|");
  }
  menu_split = menu_split.map((item) => normalizeStr(item));
  const menu_path = menu_split.join("/").replace(/\s/g, "");
  return `${area}/${menu_path}/${card}/${aba}/${nome}.${extension}`;
};

const getPathBlob = (area, menu, card, aba) => {
  area = normalizeStr(area);
  card = normalizeStr(card);
  aba = normalizeStr(aba);
  let menu_split = menu?.split("|");
  menu_split = menu_split?.map((item) => normalizeStr(item));
  const menu_path = menu_split?.join("/").replace(/\s/g, "");
  return `${area}/${menu_path}/${card}/${aba}/`;
};

export const getVersoes = async (
  area,
  menu,
  card,
  aba,
  containerName = container
) => {
  
  const containerClient = blobServiceClient.getContainerClient(containerName);
  //let i = 1;
  let arrayResponse = [];
  let path_blob = getPathBlob(area, menu, card, aba)
  let blobs = containerClient.listBlobsByHierarchy(" ", {
    prefix: path_blob,
  });
  for await (const blob of blobs) {
    let nameSplit = blob.name.split("/");
    let nameSplit2 = nameSplit[nameSplit.length - 1].split(".");
    let name = nameSplit2[0];
    arrayResponse.push({
      name: name,
      nameAll: blob.name,
      url: `${url}/${containerName}/${blob.name}`,
    });
  }
  return _.sortBy(arrayResponse, function (dateObj) {
    return moment(dateObj.name,"DD-MM-YYYY_HH:mm:ss:SS");
  }).reverse();
};

export const uploadBlob = async (
  content,
  area,
  menu,
  card,
  aba,
  type,
  extension,
  containerName = container
) => {
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const blobName = getPath(
    area,
    menu,
    card,
    aba,
    moment().format("DD-MM-YYYY_HH:mm:ss:SS"),
    extension
  );
  const blockBlobClient = containerClient.getBlockBlobClient(blobName);
  let content_type = "0";
  if (type === "download") content_type = `application/${extension}`;
  else content_type = "text/html; charset=utf-8";
  const blobOptions = {
    blobHTTPHeaders: { blobContentType: content_type },
  };
   await blockBlobClient.upload(
    content,
    content.size,
    blobOptions
  );
  return `${url}/${containerName}/${blobName}`;
};
